<template lang="pug">
    model-form(
        title="Detalle de comisión"
        :fields="fields"
        ref="form"
        reset-text="restablecer"
        submit-text="editar comisión"
        v-bind="formData"
        :switchEdit="$can('EDIT_COMMISSION')"
        :editable="false"
        v-model="modelData"
        @reset="reset"
        @submit="handleSubmit"
        )
</template>

<script>
//
import { mapActions } from 'vuex'

//
// import CrudForm from '@/components/CrudForm/CrudForm'
import { ModelForm } from '@/components/reusable_components/next'
import CommissionService from '@/services/api/commission'
import FieldsShow from './FieldsShow'
import MdlCommissions from '../../models/Sale/SlCommission'

//
export default {
    name: 'commission-show',
    props: {},
    computed: {
        /**
         *
         */
        formData() {
            return {
                // editable: true,
                // switchEdit: true,
                loading: this.formLoading,
            }
        },
    },
    data: function() {
        return {
            customRules: {
                minLength8: function(value) {
                    return value.length >= 8 ? true : 'El largo mínimo es 8'
                },
            },
            modelData: {},
            fields: FieldsShow,
            form: null,
            formData: null,
            formLoading: false,
        }
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        reset() {
            this.fetch()
            this.formLoading = true
        },
        fetch() {
            MdlCommissions.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },
        setFormData(model) {
            this.modelData = model.reset()
            this.formLoading = false
        },
        handleSubmit: async function(data) {
            new MdlCommissions(data).save().then(this.handleResponse)
        },
        setFormData: function(model) {
            this.modelData = model
        },
        fillFields: async function() {
            //
            CommissionService.fetchById(this.$route.params.id)
                .then(this.setFormData)
                .catch(this.showErrorSnackbar)
        },
        // async fillFormData() {
        //     //
        //     this.formData = {
        //         toolbarTitle: 'comisión',
        //         toolbarIcon: 'close',
        //         customRules: function(value) {
        //             return value.length >= 8 ? true : 'El largo mínimo es 8'
        //         },
        //         editable: true,
        //         disabled: false,
        //         submitText: 'editar comisión',
        //     }
        // },
        handleResponse(response) {
            if (response.status === 'success')
                return this.showSuccessSnackbar(
                    this.$router.push({ path: '/commissions/' })
                )
            //
            return this.showErrorSnackbar(response)
        },
        showErrorSnackbar(response) {
            this.initSnackbar(
                this.fillSnack('error', 'Error', response, false, 3000)
            )
        },
        showSuccessSnackbar() {
            this.initSnackbar(
                this.fillSnack(
                    'success',
                    'Éxito',
                    'La comisión fue editada exitosamente.',
                    false,
                    3000
                )
            )
        },
    },
    components: {
        'model-form': ModelForm,
    },
    beforeMount() {
        this.fillFields()
        this.setTitleTopBar('Comisión')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            let pEdit = ctx.$can('VIEW_DETAIL_COMMISSION')
            let pTypeC = ctx.$can('VIEW_ALL_COMMISSION_TYPE')
            if (!(pEdit && pTypeC)) ctx.$router.push('/')
        })
    },
}
</script>
